import axios from 'axios';

export type FetchRequestOptions = {
  signal?: AbortSignal;
};

export function isRequestAborted(err: unknown): boolean {
  if (axios.isCancel(err)) {
    return true;
  }
  const e = err as { name?: string; code?: string };
  return e.name === 'AbortError' || e.code === 'ERR_CANCELED';
}
